import type { CustomRuleSearchParams } from '~/types/loyaltyContract';

export const customRuleQueryKeys = {
  all: ['loyalty', 'custom-rules'] as const,
  searches: () => [...customRuleQueryKeys.all, 'search'] as const,
  search: (params: CustomRuleSearchParams) => [...customRuleQueryKeys.searches(), params] as const,
};
